import { Currency } from '@commercetools/frontend-sdk/lib/types/Currency';

type Country = {
  currency: Currency;
  currencyCode: string;
  countryName: string;
  countryCode: string;
  shopable: boolean;
  visible: boolean;
  hasCheckoutCfVat?: boolean;
};

type LocaleInfo = {
  country: Country;
  language: string;
};

export const LANGUAGE_NAMES: Record<string, string> = {
  de: 'Deutsch',
  en: 'English',
  it: 'Italiano',
};
const LANGUAGES: Record<string, string> = {
  de: 'de_DE',
  en: 'en_US',
  it: 'it_IT',
};
export const LANGUAGE_CODES = Object.keys(LANGUAGES);

const COUNTRIES: Record<string, Country> = {
  at: {
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'AT',
    countryName: 'Austria',
    shopable: true,
    visible: true,
  },
  de: {
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'DE',
    countryName: 'Germany',
    shopable: true,
    visible: true,
  },
  es: {
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'ES',
    countryName: 'Spain',
    shopable: true,
    visible: true,
  },
  fr: {
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'FR',
    countryName: 'France',
    shopable: true,
    visible: true,
  },
  it: {
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'IT',
    countryName: 'Italy',
    shopable: true,
    visible: true,
    hasCheckoutCfVat: true,
  },
  no: {
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'NO',
    countryName: 'World',
    shopable: false,
    visible: false,
  },
};
export const COUNTRY_KEYS = Object.keys(COUNTRIES);

export const DEFAULT_LOCALE = 'no-it';
export const DEFAULT_LANGUAGE = DEFAULT_LOCALE.slice(-2);
export const DEFAULT_COUNTRY = DEFAULT_LOCALE.slice(0, 2);

export const getLocalizationInfo = (localeString: string): LocaleInfo => {
  const language =
    localeString.slice(-2) in LANGUAGES ? LANGUAGES[localeString.slice(-2)] : LANGUAGES[DEFAULT_LANGUAGE];
  const country =
    localeString.slice(0, 2) in COUNTRIES ? COUNTRIES[localeString.slice(0, 2)] : COUNTRIES[DEFAULT_COUNTRY];
  return { country, language };
};

export const isValidLocaleString = (localeString: string): boolean => {
  return !!(
    localeString &&
    localeString.length === 5 &&
    localeString.slice(-2) in LANGUAGES &&
    localeString.slice(0, 2) in COUNTRIES
  );
};

export const getCountryFromKey = (key: string) => COUNTRIES[key];

export const getCountryFromCode = (code: string) => Object.values(COUNTRIES).find((x) => x.countryCode === code);

export const getLocaleFromPath = (path: string): string | undefined => {
  return isValidLocaleString(path.split('/')[1]) ? path.split('/')[1] : undefined;
};
export const getCountryFromPath = (path: string): string | undefined => getLocaleFromPath(path)?.slice(0, 2);
export const getLanguageFromPath = (path: string): string | undefined => getLocaleFromPath(path)?.slice(-2);

export const COMPANY_NAME = 'Grünland - Fratelli Berdin Srl';
export const COMPANY_VAT_CODE = '02283970248';
export const COMPANY_ADDRESS = 'Via Piave, 18/A, 36077 Altavilla Vicentina (VI) - Italy';
export const COMPANY_PHONE = '+39 0444 1240211';
export const COMPANY_FAX = '+39 0444 349166';
